/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const pink = {
    50: '#FFE8EC',
    100: '#FFCED8',
    200: '#FFB2C0',
    300: '#FF98AC',
    400: '#FF8199',
    500: '#FF708B',
    600: '#E25C75',
    700: '#C54A61',
    800: '#A8394E',
    900: '#8A2B3D',
    1000: '#6D1E2D',
};
